import styles from "./not-found.module.css";

const NotFound = () => {
  return <div className={styles.container}>Not found</div>;
};

export default NotFound;
